import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { classNames } from "../../ui/styles/classNames";

/**
 * The terminal's way, folded under "Use a command instead" (F47, P-F, W-06): the main path is a
 * button; a command is only ever the backup, for people who use a terminal.
 */
export default function CommandFold({ children, className }: { children: ReactNode; className?: string }) {
  const { t } = useTranslation();
  return (
    <details className={classNames("app-help-text text-xs", className)}>
      <summary className="cursor-pointer">{t("connectors.connect.useCommand")}</summary>
      <div className="mt-1 space-y-1">{children}</div>
    </details>
  );
}
